<template>
    <page>
        <module enable-flex>
            <m-search ref="search" @search="searchHandle">
                <m-search-item label="属性值">
                    <c-input name="attribute_value" maxlength="20"></c-input>
                </m-search-item>
                <m-search-item label="属性">
                    <c-select name="parent_id" async @search="searchAttribute"
                              :value-data="selectedAttribute"></c-select>
                </m-search-item>
                <m-search-item label="状态">
                    <c-checkbox-group name="status" :options="disableEnableDic"></c-checkbox-group>
                </m-search-item>
                <m-search-item label="备注">
                    <c-input name="remark" maxlength="20"></c-input>
                </m-search-item>
                <m-search-item label="添加时间" colspan="2">
                    <c-datetime range start-name="start_date" end-name="end_date"></c-datetime>
                </m-search-item>
            </m-search>

            <m-operate>
                <c-button color="main" v-if="auth('b_attribute_value_edit')" prepend-icon="tf-add"
                          @click="$refs.attributeValueAdd.open()">添加属性值
                </c-button>
            </m-operate>

            <c-table ref="list" height="grow" :paging="true">
                <c-table-column label="ID" name="id" width="80" fixed="left"></c-table-column>

                <c-table-column
                        label="属性值"
                        name="attribute_value"
                        width="120"
                        fixed="left"
                >
                </c-table-column>

                <!-- 是否启用 -->
                <c-table-column
                        label="状态"
                        name="status"
                        width="80"
                        fixed="left"
                >
                    <template #default="{data}">
                        <c-switch v-if="auth('b_attribute_value_edit')" v-model="data.status" :state-value="[1, 0]"
                                  :state-text="['启用','禁用']"
                                  @beforeChange="stateHandle(arguments[0], arguments[1], data)"></c-switch>
                        <c-state v-else dict="disableEnableDic" :value="data.status"></c-state>
                    </template>
                </c-table-column>

                <c-table-column
                        label="属性"
                        name="attribute_name"
                        width="100"
                >
                </c-table-column>

                <c-table-column
                        label="备注"
                        name="remark"
                        width="150"
                >
                    <template #default="{data}">
                        <span v-if="data.remark">{{ data.remark }}</span>
                        <span v-else>-</span>
                    </template>
                </c-table-column>

                <c-table-column
                        label="添加人"
                        name="create_user_name"
                        width="80"
                >
                </c-table-column>

                <c-table-column
                        label="添加时间"
                        name="create_time"
                        width="130"
                >
                </c-table-column>

                <c-table-column
                        label="排序"
                        type="sort"
                        fixed="right"
                        @handle="sortHandle">
                </c-table-column>

                <c-table-column
                        type="button"
                        label="操作"
                        width="175"
                        button-limit="6"
                >
                    <template #default="{data}">
                        <c-table-button v-if="auth('b_attribute_value_channel_set')" icon="tf-related" @click="$refs.channelRefEdit.open(data,data.attribute_value,'attribute_value')">渠道映射</c-table-button>
                        <c-table-button v-if="auth('b_attribute_value_edit')" icon="tf-edit" @click="$refs.attributeValueEdit.open(data)">编辑</c-table-button>
                        <c-table-button v-if="auth('b_attribute_value_edit')" icon="tf-trash" color="red" @click="removeaAttributeValue(data)">删除</c-table-button>
                    </template>
                </c-table-column>
            </c-table>
            <!--添加属性值信息弹窗-->
            <attribute-value-add ref="attributeValueAdd" @resolve="$refs.list.update()"></attribute-value-add>
            <!--编辑属性值信息弹窗-->
            <attribute-value-edit ref="attributeValueEdit" @resolve="$refs.list.update()"></attribute-value-edit>
            <!--设置关联渠道信息弹窗-->
            <channel-ref-edit ref="channelRefEdit" @resolve="$refs.list.update()"></channel-ref-edit>
        </module>
    </page>
</template>

<script>
import {mapState} from 'vuex'
import attributeValueAdd from "@/pages/spv/attribute_value_add.vue";
import attributeValueEdit from "@/pages/spv/attribute_value_edit.vue";
import channelRefEdit from "@/pages/spv/channel_ref_edit.vue";

export default {
    components: {
        attributeValueAdd,
        attributeValueEdit,
        channelRefEdit
    },
    computed: {
        // 获取dictName选项数据
        ...mapState(['disableEnableDic'])
    },

    props: {
        type: String,
        parentId: String
    },

    data() {
        return {
            selectedAttribute: [] //已选中的属性
        }
    },

    mounted() {
        var data = {};
        if (this.parentId) {
            data.parent_id = this.parentId;
            this.getAttributeDetail();
        }
        this.searchHandle(data);
    },

    methods: {
        /********搜索************/
        searchHandle(data) {
            if (!data) {
                data = {};
            }
            this.$refs.list.load({
                url: '/spu/attribute/value/list',
                data
            });
        },

        /********查询【属性】详情************/
        getAttributeDetail() {
            this.request({
                url: '/spu/attribute/detail',
                data: {
                    id: this.parentId
                },
                success: data => {
                    //已选中的[属性]
                    this.selectedAttribute = [{
                        name: data.attribute_name,
                        value: data.id
                    }];
                }
            })
        },

        /*******搜索属性*****************/
        searchAttribute(keyword, resolve) {
            this.request({
                url: '/spu/attribute/options',
                data: {
                    keyword: keyword
                },
                success: data => {
                    resolve(data);
                }
            })
        },

        /******启禁用*********/
        stateHandle(state, next, data) {
            this.request({
                url: '/spu/attribute/value/edit/status',
                data: {
                    id: data.id,
                    status: state ? 2 : 1   //1：启用； 2：禁用
                },
                success: () => {
                    this.$message({
                        message: '操作成功',  // 提示内容,
                        type: 'success'
                    });
                    next();
                }
            })
        },

        /******删除属性值***********/
        removeaAttributeValue(data) {
            this.$confirm({
                message: '确认删除属性值【' + data.attribute_value + '】？删除后不可恢复',  // 提示内容,
                // buttonName: '确定',  // 确定按钮文字
                cancelButton: true,  // 是否显示取消按钮
                resolve: () => {
                    this.request({
                        url: '/spu/attribute/value/remove',
                        data: {
                            id: data.id
                        },
                        loading: true,
                        success: data => {
                            this.$message({
                                message: '删除成功',  // 提示内容,
                                type: 'success'
                            });
                            this.$refs.list.update();
                        }
                    });
                },  // 确定按钮回调
                cancel: () => {
                },  // 取消按钮回调
            });
        },

        /********************排序**************************/
        sortHandle(row, type, next) {
            this.request({
                url: '/spu/attribute/value/sort',
                data: {
                    id: row.data.id,
                    type: ['top', 'bottom'].includes(type) ? type : '',
                    id1: type == 'up' ? row.prev().data.id : type == 'down' ? row.data.id : '',
                    id2: type == 'up' ? row.data.id : type == 'down' ? row.next().data.id : '',
                },
                loading: true,
                success: data => {
                    // next();
                    this.$refs.list.update();
                }
            });
        },
    }
}
</script>

<style lang="stylus" scoped>
</style>